import _ from 'underscore'
import Backbone from 'backbone'
import $ from 'jquery'
import {
    postRenderImages,
} from 'util/twistle'

import { contactDetailModelAugmenter } from 'util/model_augmenters'
import { renderTemplate } from 'util/template_renderer'

// Renders a conversation list in various forms (grid, list)
const ContactListItemView = Backbone.View.extend({
    className: "list_item_contact",
    options:{
        enableCreateGroups:false
    },
    events: {
        "click": "contactClicked",
        "click .item_list_column": "addContactColumnClicked",
        "click .account_startconversation": "startConversation",
        "click .new-conversation": "startConversation",
        "click .account_status_workflow_count": "contactWorkflowsClicked",
        "click .start-workflow": "startWorkflow",
    },
    initialize: function() {
        var self = this;
        self.render();
        self.model.bind('change', self.render, self);
    },
    augmentModel: function(){
        var self = this;
        var modelData = self.model.toJSON();

        _.each(modelData.relationships_info,function(r){
            // suppress non-patient relationships when a filtered view is being presented
            if(!self.options.relationshipFilter ||
                self.options.relationshipFilter !== r.relationship ||
                r.relationship === "patient" ||
                (self.options.relationshipFilter === "org-member" && r.relationship === "teammember") ||
                (r.thru_organization == self.options.orgId && r.relationship === "org-member")) {
                r.displayRelationship = true;
            } else {
                r.displayRelationship = false;
            }
            if(r.displayRelationship && r.relationship === "patient")
            {
                modelData.showContactDOB = true;
            }
            // suppress org display if org of patient matches a (org) filtered view
            if(!self.options.org_ids &&
                self.options.org_ids === r.thru_organization){
                r.organization_display = "";
            }

            // suppress the thru display for staff admin patients, just show them as staff admins
            if (r.relationship === 'org-member' && r.admin && r.thru_username === 'self') {
                r.thru_display = false;
            }

            //sometimes org_ids is a blank string, messing up template logic
            if(!self.options.org_ids || self.options.org_ids === "")
            {
                self.options.org_ids = undefined;
            }

        });
        if (self.options.searchResultMode) {
            modelData.network_count = 0; // suppress and "via xx and x others";
            modelData.canStartConversations = App.account.canStartConversations();
            modelData = contactDetailModelAugmenter(modelData);
        }
        return modelData;
    },
    render: function() {
        var self = this,
            attrs = _.defaults(self.augmentModel(), self.options);

        if(self.options.chooseMode && attrs.isPatient){
            attrs.showContactDOB = true;
        }

        if (self.options.searchResultMode) {
            self.$el.html($(renderTemplate("search_result_contact", attrs, App.account.get("locale"))));
        } else {
            self.$el.html($(renderTemplate('contact_list_item_template',attrs)));

            self.$el.addClass("contact_" + attrs.id)
                .addClass("contact_type_" + attrs.accounttype)
                .data(attrs)
                .attr("data-username",attrs.username)
                .attr("data-id",attrs.id);

            if (self.options.chooseOrgTargets
                && (((_.has(self.options.currentTargets, attrs.username) ||  _.has(self.options.addedTargets, attrs.username))
                    && !_.has(self.options.removedTargets, attrs.username))
                    || self.options.orgAccount.orgTargetAll)){
                // add the initial "org target" class if:
                // they are in the current message's targets
                // or the entire org is targeted
                // or they are about to be in the current message's targets (and not being removed)
                self.$el.addClass("org_target");
            }
            else if (self.options.chooseMode && attrs.currentParticipants && _.contains(attrs.currentParticipants, attrs.username)) {
                if (attrs.participantMap && attrs.participantMap[attrs.username]) {
                    self.$el.addClass("selected_active");
                } else {
                    self.$el.removeClass("selected_active");
                }
                if (attrs.addedParticipants && _.contains(attrs.addedParticipants, attrs.username)) {
                    self.$el.addClass("chosen");
                } else if (!self.options.chooseOrgTargets) {
                    self.$el.addClass("locked");
                }
            }

            // if we are in a group edit mode, set the initial state based on the team's members
            if (self.options.chooseTeamMembers && !self.options.viewMode &&
                (self.options.teamMembersOf.get("members") || {})[attrs.username]){
                self.$el.addClass("chosen");
                self.$(".team_select_checkbox").prop("checked",true);
            }

            self.$el.hoverClass("hovered");

            if(self.options.enableCreateGroups && _.contains(["g","r"],self.model.get("accounttype"))){
                /*
                self.$el.droppable({
                                    accept:".contact",
                                    greedy:true,
                                    hoverClass:"drop_hovered",
                                    tolerance:"pointer",
                                    drop:self.groupContactDropped
                                });
                                */
            }
            else if (self.model.get("accounttype") === "u" && !self.options.chooseMode && !App.config.get("isTouch")){
                self.$el.draggable(
                    {
                        zIndex: 99999,
                        helper: 'clone',
                        appendTo: "body",
                        start: function ()
                        {
                            App.logClickstream("contactDragStart");
                        }
                    }
                ).data("model", self.model);
            }

            // if this is in orgTarget mode, and this contact is currently selected
            /*
            if (self.options.chooseOrgTargets){
                self.$el.addClass("org_locked");
                if(self.options.orgAccount.orgTargets &&
                    self.options.orgAccount.orgTargets[attrs.username]){
                    self.$el.addClass("org_target");
                }
            }*/

            if(self.options.chooseMode && App.account.simpleUIMode())
            {
                self.$(".item_list_column").hide();
            }
        }

        postRenderImages(self.$el);

        return self;
    },

    contactClicked: function(evt) {
        var self = this;
        if (self.options.chooseMode) {
            if (self.options.chooseAboutUser) {
                App.trigger("app:set_about_user", self.model, self.options.chooseAboutUserConversation);
                self.$el.toggleClass("chosen");
            } else if (self.options.chooseTeamMembers) {
                if (!self.options.viewMode) {
                    // when in viewMode (for choosing team members) - you can't click / change their state
                    App.trigger("app:team_member_toggle", self.model);
                    self.$el.toggleClass("chosen");
                    self.$(".team_select_checkbox").prop("checked", self.$el.hasClass("chosen"));
                } else {
                    App.trigger("app:view_contact", self.model, true, true);
                }
            } else if (self.options.chooseOrgTargets) {
                App.trigger("app:add_or_remove_org_target", self.model, self.options.orgAccount.relationships_info[0], self.options.responseParticipantsView);
                //self.$el.toggleClass("org_target");
            } else if (!self.$el.hasClass("locked")) {
                App.trigger("app:add_participant_to_message", self.model, self.$el, self.options.responseParticipantsView);
            }
            App.trigger("app:remove_contact_list_filter", self.options.responseParticipantsView);
        } else {
            App.trigger("app:view_contact", self.model, true, true);
        }
        App.trigger("app:close_search");
    },

    contactWorkflowsClicked: function (evt) {
        var self = this;

        App.trigger("app:view_contact", self.model, { showWorkflowExecutions: true });
        App.stopPropagation(evt);
    },

    addContactColumnClicked: function(evt){
        var self = this;
        if (self.options.chooseMode) {
            App.trigger("app:add_participant_to_message", self.model, self.$el, self.options.responseParticipantsView);
            evt.stopPropagation();
        }
    },

    startConversation: function (evt) {
        var self = this;
        evt.preventDefault();
        evt.stopPropagation();

        App.trigger("app:search_reset");
        App.trigger("app:close_contact");
        App.trigger("app:close_search");
        App.trigger("app:new_conversation", [self.model.toJSON()]);
    },

    startWorkflow: function (evt) {
        var self = this;
        evt.preventDefault();
        evt.stopPropagation();

        App.trigger("app:search_reset");
        App.trigger("app:close_search");
        App.openDialogView(new App.WorkflowStartExecutionDialogView({
            model: self.model,
            showOrgId: self.model.toJSON().startWorkflowOrgId
        }));
    }
});

export default ContactListItemView;